<script setup>
const selectedTier = ref("basic");
const price = computed(() => {
  return selectedTier.value === "basic"
    ? 500
    : selectedTier.value === "premium"
    ? 1500
    : 0;
});
defineExpose({
  selectedTier,
  price,
});

function updatePlan(tier) {
  selectedTier.value = tier;
}
</script>

<template>
  <article>
    <header class="mb-4">
      <h2 class="text-2xl font-semibold tracking-tight text-slate-900">
        Styl strony ma znaczenie
      </h2>
      <p class="mt-2 text-slate-600">
        Twoja strona to pierwsze wrażenie, jakie robisz w sieci. Możesz postawić na
        elegancki minimalizm lub pójść o krok dalej — w stronę dopracowanego wizerunku,
        który robi wrażenie i zapada w pamięć.
      </p>
    </header>

    <!-- Wprowadzenie (bez odznak) -->
    <div class="mb-6 rounded-xl border border-slate-200 bg-slate-50 p-4 text-slate-700">
      <p class="mt-1">
        Styl strony ma znaczenie. Dobierz wariant dopasowany do Twoich oczekiwań i
        budżetu.
      </p>
    </div>

    <div
      role="radiogroup"
      aria-label="Wybór wariantu cenowego"
      class="grid gap-4 md:grid-cols-2"
    >
      <!-- Wariant 1: Estetyka gotowa do działania -->
      <label
        class="group relative cursor-pointer rounded-2xl border border-slate-200 bg-white p-5 shadow-sm transition hover:shadow-md"
        :class="selectedTier === 'basic' ? 'ring-2 ring-slate-900 bg-slate-50' : ''"
        @click="updatePlan('basic')"
      >
        <div class="flex h-full flex-col gap-3">
          <div class="flex items-center gap-3">
            <div
              class="grid w-12 aspect-square place-items-center rounded-xl bg-gradient-to-br from-slate-900 to-slate-700 text-white shadow"
            >
              💠
            </div>
            <h3 class="text-lg font-semibold text-slate-900">
              Klarowny wygląd, szybkie uruchomienie
            </h3>
          </div>
          <p class="text-slate-700">
            Korzystamy z estetycznych rozwiązań, które przyciągają uwagę i prowadzą
            użytkownika do celu. Wszystko działa płynnie i wygląda nowocześnie — bez
            zbędnego kombinowania.
          </p>
          <div class="mt-auto flex items-baseline gap-2">
            <span class="text-3xl font-bold text-slate-900">500</span>
            <span class="text-sm text-slate-500">zł</span>
          </div>
        </div>
      </label>

      <!-- Wariant 2: Wizerunek premium dla Twojej marki -->
      <label
        class="group relative cursor-pointer rounded-2xl border border-slate-200 bg-white p-5 shadow-sm transition hover:shadow-md"
        :class="selectedTier === 'premium' ? 'ring-2 ring-slate-900 bg-slate-50' : ''"
        @click="updatePlan('premium')"
      >
        <div class="flex h-full flex-col gap-3">
          <div class="flex items-center gap-3">
            <div
              class="grid w-12 aspect-square place-items-center rounded-xl bg-gradient-to-br from-indigo-600 to-sky-500 text-white shadow"
            >
              ✨
            </div>
            <h3 class="text-lg font-semibold text-slate-900">
              Design, który opowiada Twoją historię
            </h3>
          </div>
          <p class="text-slate-700">
            Zaczynamy od rozmowy o Twojej marce i odbiorcach. Na tej podstawie tworzymy
            wizualny język, który przyciąga, angażuje i wzmacnia wizerunek. Animacje,
            mikrodetale, kompozycja — wszystko ma swój cel.
          </p>
          <div class="mt-auto flex items-baseline gap-2">
            <span class="text-3xl font-bold text-slate-900">1500</span>
            <span class="text-sm text-slate-500">zł</span>
          </div>
        </div>
      </label>
    </div>
  </article>
</template>
